import { Box, Divider, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import personel from "../../../../../data/personel.json";
import MobileTherapistProfile from "./MobileTherapistProfile";
import PaperDisplayTextFromFile from "../../../../../utils/Components/PaperDisplayTextFromFile";
import PersonelHelmet from "../../../../../Helmets/PersonelHelmet";

export default function MobilePersonelPage() {
  const [activeTherapist, setActiveTherapist] = useState(
    personel.therapists[0],
  );

  function handleChangeActiveTherapist(e, newTherapist) {
    setActiveTherapist(newTherapist);
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <PersonelHelmet />
      <Box
        sx={{
          maxWidth: "90%",
          pt: 7,
        }}
      >
        <PaperDisplayTextFromFile fileName={personel.greeter} dir="misc" />
      </Box>
      <Divider />
      <Tabs value={activeTherapist} onChange={handleChangeActiveTherapist}>
        {personel.therapists.map((therapist) => (
          <Tab value={therapist} label={therapist.fullname} />
        ))}
      </Tabs>
      <Divider />
      <Box>
        {activeTherapist && (
          <MobileTherapistProfile therapist={activeTherapist} />
        )}
      </Box>
    </Box>
  );
}
